


























import ViewModel from "@/views/webtoon/Item";
export default ViewModel;
